export default function getOptionalsValue(params) {
  const valueOptional = params?.extra?.totalAmount?.value ?? 0

  if (!!valueOptional && !isNaN(valueOptional)) {
    return Math.round(valueOptional * 100) / 100
  } else {
    return 0
  }
}
